/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  AddressDTO,
  AddressDTOOptional,
  AddressDTOMetaI,
  AddressDTOTrackedI,
} from "./address-dto";
import { AddressDTOTracked, AddressDTOMeta } from "./address-dto";
// May contain unused imports in some cases
// @ts-ignore
import type {
  CardDTO,
  CardDTOOptional,
  CardDTOMetaI,
  CardDTOTrackedI,
} from "./card-dto";
import { CardDTOTracked, CardDTOMeta } from "./card-dto";
// May contain unused imports in some cases
// @ts-ignore
import type {
  DamageWaiverDTO,
  DamageWaiverDTOOptional,
  DamageWaiverDTOMetaI,
  DamageWaiverDTOTrackedI,
} from "./damage-waiver-dto";
import {
  DamageWaiverDTOTracked,
  DamageWaiverDTOMeta,
} from "./damage-waiver-dto";
// May contain unused imports in some cases
// @ts-ignore
import type {
  MembershipDTO,
  MembershipDTOOptional,
  MembershipDTOMetaI,
  MembershipDTOTrackedI,
} from "./membership-dto";
import { MembershipDTOTracked, MembershipDTOMeta } from "./membership-dto";
// May contain unused imports in some cases
// @ts-ignore
import type {
  PersonPublicChildAndParentDTO,
  PersonPublicChildAndParentDTOOptional,
  PersonPublicChildAndParentDTOMetaI,
  PersonPublicChildAndParentDTOTrackedI,
} from "./person-public-child-and-parent-dto";
import {
  PersonPublicChildAndParentDTOTracked,
  PersonPublicChildAndParentDTOMeta,
} from "./person-public-child-and-parent-dto";
// May contain unused imports in some cases
// @ts-ignore
import type {
  PersonPublicRelatedDTO,
  PersonPublicRelatedDTOOptional,
  PersonPublicRelatedDTOMetaI,
  PersonPublicRelatedDTOTrackedI,
} from "./person-public-related-dto";
import {
  PersonPublicRelatedDTOTracked,
  PersonPublicRelatedDTOMeta,
} from "./person-public-related-dto";
// May contain unused imports in some cases
// @ts-ignore
import type {
  PersonReferralDTO,
  PersonReferralDTOOptional,
  PersonReferralDTOMetaI,
  PersonReferralDTOTrackedI,
} from "./person-referral-dto";
import {
  PersonReferralDTOTracked,
  PersonReferralDTOMeta,
} from "./person-referral-dto";
// May contain unused imports in some cases
// @ts-ignore
import type {
  PersonRelationType,
  PersonRelationTypeOptional,
  PersonRelationTypeMetaI,
  PersonRelationTypeTrackedI,
} from "./person-relation-type";
import {
  PersonRelationTypeTracked,
  PersonRelationTypeMeta,
} from "./person-relation-type";
// May contain unused imports in some cases
// @ts-ignore
import type {
  PersonTypeEnum,
  PersonTypeEnumOptional,
  PersonTypeEnumMetaI,
  PersonTypeEnumTrackedI,
} from "./person-type-enum";
import { PersonTypeEnumTracked, PersonTypeEnumMeta } from "./person-type-enum";
// May contain unused imports in some cases
// @ts-ignore
import type {
  PhoneDTO,
  PhoneDTOOptional,
  PhoneDTOMetaI,
  PhoneDTOTrackedI,
} from "./phone-dto";
import { PhoneDTOTracked, PhoneDTOMeta } from "./phone-dto";
// May contain unused imports in some cases
// @ts-ignore
import type {
  SwimProof,
  SwimProofOptional,
  SwimProofMetaI,
  SwimProofTrackedI,
} from "./swim-proof";
import { SwimProofTracked, SwimProofMeta } from "./swim-proof";

/**
 *
 * @export
 * @interface PersonPublicChildDTO
 */
export interface PersonPublicChildDTOOptional extends PersonPublicChildAndParentDTOOptional {
  /**
   *
   * @type {number}
   * @memberof PersonPublicChildDTO
   */
  assignId?: number;
  /**
   *
   * @type {string}
   * @memberof PersonPublicChildDTO
   */
  prefix?: string;
  /**
   *
   * @type {string}
   * @memberof PersonPublicChildDTO
   */
  first?: string;
  /**
   *
   * @type {string}
   * @memberof PersonPublicChildDTO
   */
  middle?: string;
  /**
   *
   * @type {string}
   * @memberof PersonPublicChildDTO
   */
  last?: string;
  /**
   *
   * @type {string}
   * @memberof PersonPublicChildDTO
   */
  suffix?: string;
  /**
   *
   * @type {string}
   * @memberof PersonPublicChildDTO
   */
  preferred?: string;
  /**
   *
   * @type {string}
   * @memberof PersonPublicChildDTO
   */
  organization?: string;
  /**
   *
   * @type {string}
   * @memberof PersonPublicChildDTO
   */
  email?: string;
  /**
   *
   * @type {boolean}
   * @memberof PersonPublicChildDTO
   */
  allowSignouts?: boolean;
  /**
   *
   * @type {PersonTypeEnum}
   * @memberof PersonPublicChildDTO
   */
  personType?: PersonTypeEnum;
  /**
   *
   * @type {string}
   * @memberof PersonPublicChildDTO
   */
  allergies?: string;
  /**
   *
   * @type {string}
   * @memberof PersonPublicChildDTO
   */
  medications?: string;
  /**
   *
   * @type {string}
   * @memberof PersonPublicChildDTO
   */
  specialNeeds?: string;
  /**
   *
   * @type {string}
   * @memberof PersonPublicChildDTO
   */
  gender?: string;
  /**
   *
   * @type {string}
   * @memberof PersonPublicChildDTO
   */
  occupation?: string;
  /**
   *
   * @type {string}
   * @memberof PersonPublicChildDTO
   */
  citizenship?: string;
  /**
   *
   * @type {string}
   * @memberof PersonPublicChildDTO
   */
  ethnicity?: string;
  /**
   *
   * @type {string}
   * @memberof PersonPublicChildDTO
   */
  language?: string;
  /**
   *
   * @type {string}
   * @memberof PersonPublicChildDTO
   */
  matchingGifts?: string;
  /**
   *
   * @type {boolean}
   * @memberof PersonPublicChildDTO
   */
  student?: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonPublicChildDTO
   */
  school?: string;
  /**
   *
   * @type {string}
   * @memberof PersonPublicChildDTO
   */
  military?: string;
  /**
   *
   * @type {boolean}
   * @memberof PersonPublicChildDTO
   */
  reducedLunch?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PersonPublicChildDTO
   */
  previousMember?: boolean;
  /**
   *
   * @type {SwimProof}
   * @memberof PersonPublicChildDTO
   */
  swimProof?: SwimProof;
  /**
   *
   * @type {string}
   * @memberof PersonPublicChildDTO
   */
  dob?: Date;
  /**
   *
   * @type {boolean}
   * @memberof PersonPublicChildDTO
   */
  dobVerified?: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonPublicChildDTO
   */
  stripeCustomerId?: string;
  /**
   *
   * @type {string}
   * @memberof PersonPublicChildDTO
   */
  temp?: string;
  /**
   *
   * @type {Array<PersonReferralDTO>}
   * @memberof PersonPublicChildDTO
   */
  referrals?: PersonReferralDTOOptional[];
  /**
   *
   * @type {Array<PhoneDTO>}
   * @memberof PersonPublicChildDTO
   */
  phones?: PhoneDTOOptional[];
  /**
   *
   * @type {Array<AddressDTO>}
   * @memberof PersonPublicChildDTO
   */
  addresses?: AddressDTOOptional[];
  /**
   *
   * @type {boolean}
   * @memberof PersonPublicChildDTO
   */
  isLocked?: boolean;
  /**
   *
   * @type {Array<DamageWaiverDTO>}
   * @memberof PersonPublicChildDTO
   */
  currentDamageWaivers?: DamageWaiverDTOOptional[];
  /**
   *
   * @type {Array<MembershipDTO>}
   * @memberof PersonPublicChildDTO
   */
  currentMemberships?: MembershipDTOOptional[];
  /**
   *
   * @type {Array<CardDTO>}
   * @memberof PersonPublicChildDTO
   */
  currentCards?: CardDTOOptional[];
  /**
   *
   * @type {Array<PersonPublicRelatedDTO>}
   * @memberof PersonPublicChildDTO
   */
  emergencyContacts?: PersonPublicRelatedDTOOptional[];
  /**
   *
   * @type {number}
   * @memberof PersonPublicChildDTO
   */
  relationId?: number;
  /**
   *
   * @type {boolean}
   * @memberof PersonPublicChildDTO
   */
  isPrimary?: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonPublicChildDTO
   */
  aTitleOverride?: string;
  /**
   *
   * @type {string}
   * @memberof PersonPublicChildDTO
   */
  bTitleOverride?: string;
  /**
   *
   * @type {PersonRelationType}
   * @memberof PersonPublicChildDTO
   */
  relationTypeId?: PersonRelationType;
  /**
   *
   * @type {string}
   * @memberof PersonPublicChildDTO
   */
  aTitle?: string;
  /**
   *
   * @type {string}
   * @memberof PersonPublicChildDTO
   */
  bTitle?: string;
  /**
   *
   * @type {boolean}
   * @memberof PersonPublicChildDTO
   */
  isDeleted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PersonPublicChildDTO
   */
  isNew?: boolean;
}

export interface PersonPublicChildDTO
  extends
    PersonPublicChildDTOOptional,
    PersonPublicChildAndParentDTO,
    PersonPublicRelatedDTO {
  /**
   *
   * @type {number}
   * @memberof PersonPublicChildDTO
   */
  assignId: number;
  /**
   *
   * @type {string}
   * @memberof PersonPublicChildDTO
   */
  prefix?: string;
  /**
   *
   * @type {string}
   * @memberof PersonPublicChildDTO
   */
  first?: string;
  /**
   *
   * @type {string}
   * @memberof PersonPublicChildDTO
   */
  middle?: string;
  /**
   *
   * @type {string}
   * @memberof PersonPublicChildDTO
   */
  last?: string;
  /**
   *
   * @type {string}
   * @memberof PersonPublicChildDTO
   */
  suffix?: string;
  /**
   *
   * @type {string}
   * @memberof PersonPublicChildDTO
   */
  preferred?: string;
  /**
   *
   * @type {string}
   * @memberof PersonPublicChildDTO
   */
  organization?: string;
  /**
   *
   * @type {string}
   * @memberof PersonPublicChildDTO
   */
  email?: string;
  /**
   *
   * @type {boolean}
   * @memberof PersonPublicChildDTO
   */
  allowSignouts?: boolean;
  /**
   *
   * @type {PersonTypeEnum}
   * @memberof PersonPublicChildDTO
   */
  personType?: PersonTypeEnum;
  /**
   *
   * @type {string}
   * @memberof PersonPublicChildDTO
   */
  allergies?: string;
  /**
   *
   * @type {string}
   * @memberof PersonPublicChildDTO
   */
  medications?: string;
  /**
   *
   * @type {string}
   * @memberof PersonPublicChildDTO
   */
  specialNeeds?: string;
  /**
   *
   * @type {string}
   * @memberof PersonPublicChildDTO
   */
  gender?: string;
  /**
   *
   * @type {string}
   * @memberof PersonPublicChildDTO
   */
  occupation?: string;
  /**
   *
   * @type {string}
   * @memberof PersonPublicChildDTO
   */
  citizenship?: string;
  /**
   *
   * @type {string}
   * @memberof PersonPublicChildDTO
   */
  ethnicity?: string;
  /**
   *
   * @type {string}
   * @memberof PersonPublicChildDTO
   */
  language?: string;
  /**
   *
   * @type {string}
   * @memberof PersonPublicChildDTO
   */
  matchingGifts?: string;
  /**
   *
   * @type {boolean}
   * @memberof PersonPublicChildDTO
   */
  student?: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonPublicChildDTO
   */
  school?: string;
  /**
   *
   * @type {string}
   * @memberof PersonPublicChildDTO
   */
  military?: string;
  /**
   *
   * @type {boolean}
   * @memberof PersonPublicChildDTO
   */
  reducedLunch?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PersonPublicChildDTO
   */
  previousMember?: boolean;
  /**
   *
   * @type {SwimProof}
   * @memberof PersonPublicChildDTO
   */
  swimProof?: SwimProof;
  /**
   *
   * @type {string}
   * @memberof PersonPublicChildDTO
   */
  dob?: Date;
  /**
   *
   * @type {boolean}
   * @memberof PersonPublicChildDTO
   */
  dobVerified?: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonPublicChildDTO
   */
  stripeCustomerId?: string;
  /**
   *
   * @type {string}
   * @memberof PersonPublicChildDTO
   */
  temp: string;
  /**
   *
   * @type {Array<PersonReferralDTO>}
   * @memberof PersonPublicChildDTO
   */
  referrals?: PersonReferralDTO[];
  /**
   *
   * @type {Array<PhoneDTO>}
   * @memberof PersonPublicChildDTO
   */
  phones?: PhoneDTO[];
  /**
   *
   * @type {Array<AddressDTO>}
   * @memberof PersonPublicChildDTO
   */
  addresses?: AddressDTO[];
  /**
   *
   * @type {boolean}
   * @memberof PersonPublicChildDTO
   */
  isLocked?: boolean;
  /**
   *
   * @type {Array<DamageWaiverDTO>}
   * @memberof PersonPublicChildDTO
   */
  currentDamageWaivers?: DamageWaiverDTO[];
  /**
   *
   * @type {Array<MembershipDTO>}
   * @memberof PersonPublicChildDTO
   */
  currentMemberships?: MembershipDTO[];
  /**
   *
   * @type {Array<CardDTO>}
   * @memberof PersonPublicChildDTO
   */
  currentCards?: CardDTO[];
  /**
   *
   * @type {Array<PersonPublicRelatedDTO>}
   * @memberof PersonPublicChildDTO
   */
  emergencyContacts?: PersonPublicRelatedDTO[];
  /**
   *
   * @type {number}
   * @memberof PersonPublicChildDTO
   */
  relationId: number;
  /**
   *
   * @type {boolean}
   * @memberof PersonPublicChildDTO
   */
  isPrimary?: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonPublicChildDTO
   */
  aTitleOverride?: string;
  /**
   *
   * @type {string}
   * @memberof PersonPublicChildDTO
   */
  bTitleOverride?: string;
  /**
   *
   * @type {PersonRelationType}
   * @memberof PersonPublicChildDTO
   */
  relationTypeId?: PersonRelationType;
  /**
   *
   * @type {string}
   * @memberof PersonPublicChildDTO
   */
  aTitle?: string;
  /**
   *
   * @type {string}
   * @memberof PersonPublicChildDTO
   */
  bTitle?: string;
  /**
   *
   * @type {boolean}
   * @memberof PersonPublicChildDTO
   */
  isDeleted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PersonPublicChildDTO
   */
  isNew?: boolean;
}

export interface PersonPublicChildDTOTrackedI extends PersonPublicChildAndParentDTOOptional {
  /**
   *
   * @type {number}
   * @memberof PersonPublicChildDTO
   */
  assignId?: number;
  assignIdIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonPublicChildDTO
   */
  prefix?: string;
  prefixIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonPublicChildDTO
   */
  first?: string;
  firstIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonPublicChildDTO
   */
  middle?: string;
  middleIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonPublicChildDTO
   */
  last?: string;
  lastIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonPublicChildDTO
   */
  suffix?: string;
  suffixIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonPublicChildDTO
   */
  preferred?: string;
  preferredIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonPublicChildDTO
   */
  organization?: string;
  organizationIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonPublicChildDTO
   */
  email?: string;
  emailIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PersonPublicChildDTO
   */
  allowSignouts?: boolean;
  allowSignoutsIsSet: boolean;
  /**
   *
   * @type {PersonTypeEnum}
   * @memberof PersonPublicChildDTO
   */
  personType?: PersonTypeEnum;
  personTypeIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonPublicChildDTO
   */
  allergies?: string;
  allergiesIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonPublicChildDTO
   */
  medications?: string;
  medicationsIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonPublicChildDTO
   */
  specialNeeds?: string;
  specialNeedsIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonPublicChildDTO
   */
  gender?: string;
  genderIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonPublicChildDTO
   */
  occupation?: string;
  occupationIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonPublicChildDTO
   */
  citizenship?: string;
  citizenshipIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonPublicChildDTO
   */
  ethnicity?: string;
  ethnicityIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonPublicChildDTO
   */
  language?: string;
  languageIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonPublicChildDTO
   */
  matchingGifts?: string;
  matchingGiftsIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PersonPublicChildDTO
   */
  student?: boolean;
  studentIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonPublicChildDTO
   */
  school?: string;
  schoolIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonPublicChildDTO
   */
  military?: string;
  militaryIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PersonPublicChildDTO
   */
  reducedLunch?: boolean;
  reducedLunchIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PersonPublicChildDTO
   */
  previousMember?: boolean;
  previousMemberIsSet: boolean;
  /**
   *
   * @type {SwimProof}
   * @memberof PersonPublicChildDTO
   */
  swimProof?: SwimProof;
  swimProofIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonPublicChildDTO
   */
  dob?: Date;
  dobIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PersonPublicChildDTO
   */
  dobVerified?: boolean;
  dobVerifiedIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonPublicChildDTO
   */
  stripeCustomerId?: string;
  stripeCustomerIdIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonPublicChildDTO
   */
  temp?: string;
  tempIsSet: boolean;
  /**
   *
   * @type {Array<PersonReferralDTO>}
   * @memberof PersonPublicChildDTO
   */
  referrals?: PersonReferralDTOTrackedI[];
  referralsIsSet: boolean;
  /**
   *
   * @type {Array<PhoneDTO>}
   * @memberof PersonPublicChildDTO
   */
  phones?: PhoneDTOTrackedI[];
  phonesIsSet: boolean;
  /**
   *
   * @type {Array<AddressDTO>}
   * @memberof PersonPublicChildDTO
   */
  addresses?: AddressDTOTrackedI[];
  addressesIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PersonPublicChildDTO
   */
  isLocked?: boolean;
  isLockedIsSet: boolean;
  /**
   *
   * @type {Array<DamageWaiverDTO>}
   * @memberof PersonPublicChildDTO
   */
  currentDamageWaivers?: DamageWaiverDTOTrackedI[];
  currentDamageWaiversIsSet: boolean;
  /**
   *
   * @type {Array<MembershipDTO>}
   * @memberof PersonPublicChildDTO
   */
  currentMemberships?: MembershipDTOTrackedI[];
  currentMembershipsIsSet: boolean;
  /**
   *
   * @type {Array<CardDTO>}
   * @memberof PersonPublicChildDTO
   */
  currentCards?: CardDTOTrackedI[];
  currentCardsIsSet: boolean;
  /**
   *
   * @type {Array<PersonPublicRelatedDTO>}
   * @memberof PersonPublicChildDTO
   */
  emergencyContacts?: PersonPublicRelatedDTOTrackedI[];
  emergencyContactsIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof PersonPublicChildDTO
   */
  relationId?: number;
  relationIdIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PersonPublicChildDTO
   */
  isPrimary?: boolean;
  isPrimaryIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonPublicChildDTO
   */
  aTitleOverride?: string;
  aTitleOverrideIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonPublicChildDTO
   */
  bTitleOverride?: string;
  bTitleOverrideIsSet: boolean;
  /**
   *
   * @type {PersonRelationType}
   * @memberof PersonPublicChildDTO
   */
  relationTypeId?: PersonRelationType;
  relationTypeIdIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonPublicChildDTO
   */
  aTitle?: string;
  aTitleIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonPublicChildDTO
   */
  bTitle?: string;
  bTitleIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PersonPublicChildDTO
   */
  isDeleted?: boolean;
  isDeletedIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PersonPublicChildDTO
   */
  isNew?: boolean;
  isNewIsSet: boolean;
}

transformDatesMap.set(
  "PersonPublicChildDTO",
  function (model: PersonPublicChildDTO) {
    if (typeof model.dob == "string") model.dob = new Date(model.dob);
    const transformDatesreferrals = transformDatesMap.get("PersonReferralDTO");
    if (transformDatesreferrals) {
      model.referrals?.forEach((sub) => {
        transformDatesreferrals(sub);
      });
    }
    const transformDatesphones = transformDatesMap.get("PhoneDTO");
    if (transformDatesphones) {
      model.phones?.forEach((sub) => {
        transformDatesphones(sub);
      });
    }
    const transformDatesaddresses = transformDatesMap.get("AddressDTO");
    if (transformDatesaddresses) {
      model.addresses?.forEach((sub) => {
        transformDatesaddresses(sub);
      });
    }
    const transformDatescurrentDamageWaivers =
      transformDatesMap.get("DamageWaiverDTO");
    if (transformDatescurrentDamageWaivers) {
      model.currentDamageWaivers?.forEach((sub) => {
        transformDatescurrentDamageWaivers(sub);
      });
    }
    const transformDatescurrentMemberships =
      transformDatesMap.get("MembershipDTO");
    if (transformDatescurrentMemberships) {
      model.currentMemberships?.forEach((sub) => {
        transformDatescurrentMemberships(sub);
      });
    }
    const transformDatescurrentCards = transformDatesMap.get("CardDTO");
    if (transformDatescurrentCards) {
      model.currentCards?.forEach((sub) => {
        transformDatescurrentCards(sub);
      });
    }
    const transformDatesemergencyContacts = transformDatesMap.get(
      "PersonPublicRelatedDTO",
    );
    if (transformDatesemergencyContacts) {
      model.emergencyContacts?.forEach((sub) => {
        transformDatesemergencyContacts(sub);
      });
    }
  },
);

export type PersonPublicChildDTOMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  assignId: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  prefix: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  first: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  middle: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  last: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  suffix: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  preferred: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  organization: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  email: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  allowSignouts: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  personType: PropertyMeta<PersonTypeEnumMetaI>;
  //isDate: false
  //isDatetime: false
  allergies: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  medications: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  specialNeeds: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  gender: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  occupation: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  citizenship: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  ethnicity: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  language: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  matchingGifts: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  student: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  school: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  military: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  reducedLunch: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  previousMember: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  swimProof: PropertyMeta<SwimProofMetaI>;
  //isDate: false
  //isDatetime: true
  dob: PropertyMeta<MetaTypeBase<Date>>;
  //isDate: false
  //isDatetime: false
  dobVerified: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  stripeCustomerId: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  temp: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  referrals: PropertyMeta<PersonReferralDTOMetaI>;
  //isDate: false
  //isDatetime: false
  phones: PropertyMeta<PhoneDTOMetaI>;
  //isDate: false
  //isDatetime: false
  addresses: PropertyMeta<AddressDTOMetaI>;
  //isDate: false
  //isDatetime: false
  isLocked: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  currentDamageWaivers: PropertyMeta<DamageWaiverDTOMetaI>;
  //isDate: false
  //isDatetime: false
  currentMemberships: PropertyMeta<MembershipDTOMetaI>;
  //isDate: false
  //isDatetime: false
  currentCards: PropertyMeta<CardDTOMetaI>;
  //isDate: false
  //isDatetime: false
  emergencyContacts: PropertyMeta<PersonPublicRelatedDTOMetaI>;
  //isDate: false
  //isDatetime: false
  relationId: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  isPrimary: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  aTitleOverride: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  bTitleOverride: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  relationTypeId: PropertyMeta<PersonRelationTypeMetaI>;
  //isDate: false
  //isDatetime: false
  aTitle: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  bTitle: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  isDeleted: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  isNew: PropertyMeta<MetaTypeBase<boolean>>;
}>;

export var PersonPublicChildDTOMeta: PersonPublicChildDTOMetaI =
  {} as PersonPublicChildDTOMetaI;
PersonPublicChildDTOMeta = typeMeta("PersonPublicChildDTO", {
  assignId: propertyMeta("assignId", false, true, true, MetaTypesBase.number),
  prefix: propertyMeta("prefix", false, false, false, MetaTypesBase.string),
  first: propertyMeta("first", false, false, false, MetaTypesBase.string),
  middle: propertyMeta("middle", false, false, false, MetaTypesBase.string),
  last: propertyMeta("last", false, false, false, MetaTypesBase.string),
  suffix: propertyMeta("suffix", false, false, false, MetaTypesBase.string),
  preferred: propertyMeta(
    "preferred",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  organization: propertyMeta(
    "organization",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  email: propertyMeta("email", false, false, false, MetaTypesBase.string),
  allowSignouts: propertyMeta(
    "allowSignouts",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  personType: propertyMeta(
    "personType",
    false,
    false,
    false,
    PersonTypeEnumMeta,
  ),
  allergies: propertyMeta(
    "allergies",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  medications: propertyMeta(
    "medications",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  specialNeeds: propertyMeta(
    "specialNeeds",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  gender: propertyMeta("gender", false, false, false, MetaTypesBase.string),
  occupation: propertyMeta(
    "occupation",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  citizenship: propertyMeta(
    "citizenship",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  ethnicity: propertyMeta(
    "ethnicity",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  language: propertyMeta("language", false, false, false, MetaTypesBase.string),
  matchingGifts: propertyMeta(
    "matchingGifts",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  student: propertyMeta("student", false, false, false, MetaTypesBase.boolean),
  school: propertyMeta("school", false, false, false, MetaTypesBase.string),
  military: propertyMeta("military", false, false, false, MetaTypesBase.string),
  reducedLunch: propertyMeta(
    "reducedLunch",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  previousMember: propertyMeta(
    "previousMember",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  swimProof: propertyMeta("swimProof", false, false, false, SwimProofMeta),
  dob: propertyMeta("dob", false, false, false, MetaTypesBase.Date),
  dobVerified: propertyMeta(
    "dobVerified",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  stripeCustomerId: propertyMeta(
    "stripeCustomerId",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  temp: propertyMeta("temp", false, true, false, MetaTypesBase.string),
  referrals: propertyMeta(
    "referrals",
    true,
    false,
    false,
    PersonReferralDTOMeta,
  ),
  phones: propertyMeta("phones", true, false, false, PhoneDTOMeta),
  addresses: propertyMeta("addresses", true, false, false, AddressDTOMeta),
  isLocked: propertyMeta(
    "isLocked",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  currentDamageWaivers: propertyMeta(
    "currentDamageWaivers",
    true,
    false,
    false,
    DamageWaiverDTOMeta,
  ),
  currentMemberships: propertyMeta(
    "currentMemberships",
    true,
    false,
    false,
    MembershipDTOMeta,
  ),
  currentCards: propertyMeta("currentCards", true, false, false, CardDTOMeta),
  emergencyContacts: propertyMeta(
    "emergencyContacts",
    true,
    false,
    false,
    PersonPublicRelatedDTOMeta,
  ),
  relationId: propertyMeta(
    "relationId",
    false,
    true,
    true,
    MetaTypesBase.number,
  ),
  isPrimary: propertyMeta(
    "isPrimary",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  aTitleOverride: propertyMeta(
    "aTitleOverride",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  bTitleOverride: propertyMeta(
    "bTitleOverride",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  relationTypeId: propertyMeta(
    "relationTypeId",
    false,
    false,
    false,
    PersonRelationTypeMeta,
  ),
  aTitle: propertyMeta("aTitle", false, false, false, MetaTypesBase.string),
  bTitle: propertyMeta("bTitle", false, false, false, MetaTypesBase.string),
  isDeleted: propertyMeta(
    "isDeleted",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  isNew: propertyMeta("isNew", false, false, false, MetaTypesBase.boolean),
});

const metaI = PersonPublicChildDTOMeta;

registerMeta(() => {
  metaI.interfaces = metaI.interfaces.concat([
    PersonPublicChildAndParentDTOMeta,
  ]);
  metaI.assignId.inheritedFrom = PersonPublicChildAndParentDTOMeta.assignId;
  metaI.prefix.inheritedFrom = PersonPublicChildAndParentDTOMeta.prefix;
  metaI.first.inheritedFrom = PersonPublicChildAndParentDTOMeta.first;
  metaI.middle.inheritedFrom = PersonPublicChildAndParentDTOMeta.middle;
  metaI.last.inheritedFrom = PersonPublicChildAndParentDTOMeta.last;
  metaI.suffix.inheritedFrom = PersonPublicChildAndParentDTOMeta.suffix;
  metaI.preferred.inheritedFrom = PersonPublicChildAndParentDTOMeta.preferred;
  metaI.organization.inheritedFrom =
    PersonPublicChildAndParentDTOMeta.organization;
  metaI.email.inheritedFrom = PersonPublicChildAndParentDTOMeta.email;
  metaI.allowSignouts.inheritedFrom =
    PersonPublicChildAndParentDTOMeta.allowSignouts;
  metaI.personType.inheritedFrom = PersonPublicChildAndParentDTOMeta.personType;
  metaI.allergies.inheritedFrom = PersonPublicChildAndParentDTOMeta.allergies;
  metaI.medications.inheritedFrom =
    PersonPublicChildAndParentDTOMeta.medications;
  metaI.specialNeeds.inheritedFrom =
    PersonPublicChildAndParentDTOMeta.specialNeeds;
  metaI.gender.inheritedFrom = PersonPublicChildAndParentDTOMeta.gender;
  metaI.occupation.inheritedFrom = PersonPublicChildAndParentDTOMeta.occupation;
  metaI.citizenship.inheritedFrom =
    PersonPublicChildAndParentDTOMeta.citizenship;
  metaI.ethnicity.inheritedFrom = PersonPublicChildAndParentDTOMeta.ethnicity;
  metaI.language.inheritedFrom = PersonPublicChildAndParentDTOMeta.language;
  metaI.matchingGifts.inheritedFrom =
    PersonPublicChildAndParentDTOMeta.matchingGifts;
  metaI.student.inheritedFrom = PersonPublicChildAndParentDTOMeta.student;
  metaI.school.inheritedFrom = PersonPublicChildAndParentDTOMeta.school;
  metaI.military.inheritedFrom = PersonPublicChildAndParentDTOMeta.military;
  metaI.reducedLunch.inheritedFrom =
    PersonPublicChildAndParentDTOMeta.reducedLunch;
  metaI.previousMember.inheritedFrom =
    PersonPublicChildAndParentDTOMeta.previousMember;
  metaI.swimProof.inheritedFrom = PersonPublicChildAndParentDTOMeta.swimProof;
  metaI.dob.inheritedFrom = PersonPublicChildAndParentDTOMeta.dob;
  metaI.dobVerified.inheritedFrom =
    PersonPublicChildAndParentDTOMeta.dobVerified;
  metaI.stripeCustomerId.inheritedFrom =
    PersonPublicChildAndParentDTOMeta.stripeCustomerId;
  metaI.temp.inheritedFrom = PersonPublicChildAndParentDTOMeta.temp;
  metaI.referrals.inheritedFrom = PersonPublicChildAndParentDTOMeta.referrals;
  metaI.phones.inheritedFrom = PersonPublicChildAndParentDTOMeta.phones;
  metaI.addresses.inheritedFrom = PersonPublicChildAndParentDTOMeta.addresses;
  metaI.isLocked.inheritedFrom = PersonPublicChildAndParentDTOMeta.isLocked;
  metaI.currentDamageWaivers.inheritedFrom =
    PersonPublicChildAndParentDTOMeta.currentDamageWaivers;
  metaI.currentMemberships.inheritedFrom =
    PersonPublicChildAndParentDTOMeta.currentMemberships;
  metaI.currentCards.inheritedFrom =
    PersonPublicChildAndParentDTOMeta.currentCards;
  metaI.emergencyContacts.inheritedFrom =
    PersonPublicChildAndParentDTOMeta.emergencyContacts;
  metaI.interfaces = metaI.interfaces.concat([PersonPublicRelatedDTOMeta]);
  metaI.assignId.inheritedFrom = PersonPublicRelatedDTOMeta.assignId;
  metaI.prefix.inheritedFrom = PersonPublicRelatedDTOMeta.prefix;
  metaI.first.inheritedFrom = PersonPublicRelatedDTOMeta.first;
  metaI.middle.inheritedFrom = PersonPublicRelatedDTOMeta.middle;
  metaI.last.inheritedFrom = PersonPublicRelatedDTOMeta.last;
  metaI.suffix.inheritedFrom = PersonPublicRelatedDTOMeta.suffix;
  metaI.preferred.inheritedFrom = PersonPublicRelatedDTOMeta.preferred;
  metaI.organization.inheritedFrom = PersonPublicRelatedDTOMeta.organization;
  metaI.email.inheritedFrom = PersonPublicRelatedDTOMeta.email;
  metaI.allowSignouts.inheritedFrom = PersonPublicRelatedDTOMeta.allowSignouts;
  metaI.personType.inheritedFrom = PersonPublicRelatedDTOMeta.personType;
  metaI.allergies.inheritedFrom = PersonPublicRelatedDTOMeta.allergies;
  metaI.medications.inheritedFrom = PersonPublicRelatedDTOMeta.medications;
  metaI.specialNeeds.inheritedFrom = PersonPublicRelatedDTOMeta.specialNeeds;
  metaI.gender.inheritedFrom = PersonPublicRelatedDTOMeta.gender;
  metaI.occupation.inheritedFrom = PersonPublicRelatedDTOMeta.occupation;
  metaI.citizenship.inheritedFrom = PersonPublicRelatedDTOMeta.citizenship;
  metaI.ethnicity.inheritedFrom = PersonPublicRelatedDTOMeta.ethnicity;
  metaI.language.inheritedFrom = PersonPublicRelatedDTOMeta.language;
  metaI.matchingGifts.inheritedFrom = PersonPublicRelatedDTOMeta.matchingGifts;
  metaI.student.inheritedFrom = PersonPublicRelatedDTOMeta.student;
  metaI.school.inheritedFrom = PersonPublicRelatedDTOMeta.school;
  metaI.military.inheritedFrom = PersonPublicRelatedDTOMeta.military;
  metaI.reducedLunch.inheritedFrom = PersonPublicRelatedDTOMeta.reducedLunch;
  metaI.previousMember.inheritedFrom =
    PersonPublicRelatedDTOMeta.previousMember;
  metaI.swimProof.inheritedFrom = PersonPublicRelatedDTOMeta.swimProof;
  metaI.dob.inheritedFrom = PersonPublicRelatedDTOMeta.dob;
  metaI.dobVerified.inheritedFrom = PersonPublicRelatedDTOMeta.dobVerified;
  metaI.stripeCustomerId.inheritedFrom =
    PersonPublicRelatedDTOMeta.stripeCustomerId;
  metaI.temp.inheritedFrom = PersonPublicRelatedDTOMeta.temp;
  metaI.referrals.inheritedFrom = PersonPublicRelatedDTOMeta.referrals;
  metaI.phones.inheritedFrom = PersonPublicRelatedDTOMeta.phones;
  metaI.addresses.inheritedFrom = PersonPublicRelatedDTOMeta.addresses;
  metaI.isLocked.inheritedFrom = PersonPublicRelatedDTOMeta.isLocked;
  metaI.relationId.inheritedFrom = PersonPublicRelatedDTOMeta.relationId;
  metaI.isPrimary.inheritedFrom = PersonPublicRelatedDTOMeta.isPrimary;
  metaI.aTitleOverride.inheritedFrom =
    PersonPublicRelatedDTOMeta.aTitleOverride;
  metaI.bTitleOverride.inheritedFrom =
    PersonPublicRelatedDTOMeta.bTitleOverride;
  metaI.relationTypeId.inheritedFrom =
    PersonPublicRelatedDTOMeta.relationTypeId;
  metaI.aTitle.inheritedFrom = PersonPublicRelatedDTOMeta.aTitle;
  metaI.bTitle.inheritedFrom = PersonPublicRelatedDTOMeta.bTitle;
  metaI.isDeleted.inheritedFrom = PersonPublicRelatedDTOMeta.isDeleted;
  metaI.isNew.inheritedFrom = PersonPublicRelatedDTOMeta.isNew;
});

export class PersonPublicChildDTOTracked
  extends PersonPublicChildAndParentDTOTracked
  implements PersonPublicChildDTOTrackedI
{
  changeTracker: boolean = false;
  //isNew: boolean = false
  assignId__I?: number = undefined;

  get assignIdIsSet() {
    return this.assignId !== undefined;
  }
  set assignIdIsSet(v: boolean) {}
  set assignId(v: undefined | number) {
    if (v !== undefined) {
      this.assignId__I = v;
      this.assignIdIsSet = true;
    } else {
      this.assignId__I = v || undefined;
      this.assignIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get assignId() {
    return this.assignId__I;
  }
  prefix__I?: string = undefined;
  prefixIsSet: boolean = false;
  set prefix(v: undefined | string) {
    if (v !== undefined) {
      this.prefix__I = v;
      this.prefixIsSet = true;
    } else {
      this.prefix__I = v || undefined;
      this.prefixIsSet = false;
    }
    this.changeTracker = true;
  }
  get prefix() {
    return this.prefix__I;
  }
  first__I?: string = undefined;
  firstIsSet: boolean = false;
  set first(v: undefined | string) {
    if (v !== undefined) {
      this.first__I = v;
      this.firstIsSet = true;
    } else {
      this.first__I = v || undefined;
      this.firstIsSet = false;
    }
    this.changeTracker = true;
  }
  get first() {
    return this.first__I;
  }
  middle__I?: string = undefined;
  middleIsSet: boolean = false;
  set middle(v: undefined | string) {
    if (v !== undefined) {
      this.middle__I = v;
      this.middleIsSet = true;
    } else {
      this.middle__I = v || undefined;
      this.middleIsSet = false;
    }
    this.changeTracker = true;
  }
  get middle() {
    return this.middle__I;
  }
  last__I?: string = undefined;
  lastIsSet: boolean = false;
  set last(v: undefined | string) {
    if (v !== undefined) {
      this.last__I = v;
      this.lastIsSet = true;
    } else {
      this.last__I = v || undefined;
      this.lastIsSet = false;
    }
    this.changeTracker = true;
  }
  get last() {
    return this.last__I;
  }
  suffix__I?: string = undefined;
  suffixIsSet: boolean = false;
  set suffix(v: undefined | string) {
    if (v !== undefined) {
      this.suffix__I = v;
      this.suffixIsSet = true;
    } else {
      this.suffix__I = v || undefined;
      this.suffixIsSet = false;
    }
    this.changeTracker = true;
  }
  get suffix() {
    return this.suffix__I;
  }
  preferred__I?: string = undefined;
  preferredIsSet: boolean = false;
  set preferred(v: undefined | string) {
    if (v !== undefined) {
      this.preferred__I = v;
      this.preferredIsSet = true;
    } else {
      this.preferred__I = v || undefined;
      this.preferredIsSet = false;
    }
    this.changeTracker = true;
  }
  get preferred() {
    return this.preferred__I;
  }
  organization__I?: string = undefined;
  organizationIsSet: boolean = false;
  set organization(v: undefined | string) {
    if (v !== undefined) {
      this.organization__I = v;
      this.organizationIsSet = true;
    } else {
      this.organization__I = v || undefined;
      this.organizationIsSet = false;
    }
    this.changeTracker = true;
  }
  get organization() {
    return this.organization__I;
  }
  email__I?: string = undefined;
  emailIsSet: boolean = false;
  set email(v: undefined | string) {
    if (v !== undefined) {
      this.email__I = v;
      this.emailIsSet = true;
    } else {
      this.email__I = v || undefined;
      this.emailIsSet = false;
    }
    this.changeTracker = true;
  }
  get email() {
    return this.email__I;
  }
  allowSignouts__I?: boolean = undefined;
  allowSignoutsIsSet: boolean = false;
  set allowSignouts(v: undefined | boolean) {
    if (v !== undefined) {
      this.allowSignouts__I = v;
      this.allowSignoutsIsSet = true;
    } else {
      this.allowSignouts__I = v || undefined;
      this.allowSignoutsIsSet = false;
    }
    this.changeTracker = true;
  }
  get allowSignouts() {
    return this.allowSignouts__I;
  }
  personType__I?: PersonTypeEnum = undefined;
  personTypeIsSet: boolean = false;
  set personType(v: undefined | PersonTypeEnum) {
    if (v !== undefined) {
      this.personType__I = v;
      this.personTypeIsSet = true;
    } else {
      this.personType__I = v || undefined;
      this.personTypeIsSet = false;
    }
    this.changeTracker = true;
  }
  get personType() {
    return this.personType__I;
  }
  allergies__I?: string = undefined;
  allergiesIsSet: boolean = false;
  set allergies(v: undefined | string) {
    if (v !== undefined) {
      this.allergies__I = v;
      this.allergiesIsSet = true;
    } else {
      this.allergies__I = v || undefined;
      this.allergiesIsSet = false;
    }
    this.changeTracker = true;
  }
  get allergies() {
    return this.allergies__I;
  }
  medications__I?: string = undefined;
  medicationsIsSet: boolean = false;
  set medications(v: undefined | string) {
    if (v !== undefined) {
      this.medications__I = v;
      this.medicationsIsSet = true;
    } else {
      this.medications__I = v || undefined;
      this.medicationsIsSet = false;
    }
    this.changeTracker = true;
  }
  get medications() {
    return this.medications__I;
  }
  specialNeeds__I?: string = undefined;
  specialNeedsIsSet: boolean = false;
  set specialNeeds(v: undefined | string) {
    if (v !== undefined) {
      this.specialNeeds__I = v;
      this.specialNeedsIsSet = true;
    } else {
      this.specialNeeds__I = v || undefined;
      this.specialNeedsIsSet = false;
    }
    this.changeTracker = true;
  }
  get specialNeeds() {
    return this.specialNeeds__I;
  }
  gender__I?: string = undefined;
  genderIsSet: boolean = false;
  set gender(v: undefined | string) {
    if (v !== undefined) {
      this.gender__I = v;
      this.genderIsSet = true;
    } else {
      this.gender__I = v || undefined;
      this.genderIsSet = false;
    }
    this.changeTracker = true;
  }
  get gender() {
    return this.gender__I;
  }
  occupation__I?: string = undefined;
  occupationIsSet: boolean = false;
  set occupation(v: undefined | string) {
    if (v !== undefined) {
      this.occupation__I = v;
      this.occupationIsSet = true;
    } else {
      this.occupation__I = v || undefined;
      this.occupationIsSet = false;
    }
    this.changeTracker = true;
  }
  get occupation() {
    return this.occupation__I;
  }
  citizenship__I?: string = undefined;
  citizenshipIsSet: boolean = false;
  set citizenship(v: undefined | string) {
    if (v !== undefined) {
      this.citizenship__I = v;
      this.citizenshipIsSet = true;
    } else {
      this.citizenship__I = v || undefined;
      this.citizenshipIsSet = false;
    }
    this.changeTracker = true;
  }
  get citizenship() {
    return this.citizenship__I;
  }
  ethnicity__I?: string = undefined;
  ethnicityIsSet: boolean = false;
  set ethnicity(v: undefined | string) {
    if (v !== undefined) {
      this.ethnicity__I = v;
      this.ethnicityIsSet = true;
    } else {
      this.ethnicity__I = v || undefined;
      this.ethnicityIsSet = false;
    }
    this.changeTracker = true;
  }
  get ethnicity() {
    return this.ethnicity__I;
  }
  language__I?: string = undefined;
  languageIsSet: boolean = false;
  set language(v: undefined | string) {
    if (v !== undefined) {
      this.language__I = v;
      this.languageIsSet = true;
    } else {
      this.language__I = v || undefined;
      this.languageIsSet = false;
    }
    this.changeTracker = true;
  }
  get language() {
    return this.language__I;
  }
  matchingGifts__I?: string = undefined;
  matchingGiftsIsSet: boolean = false;
  set matchingGifts(v: undefined | string) {
    if (v !== undefined) {
      this.matchingGifts__I = v;
      this.matchingGiftsIsSet = true;
    } else {
      this.matchingGifts__I = v || undefined;
      this.matchingGiftsIsSet = false;
    }
    this.changeTracker = true;
  }
  get matchingGifts() {
    return this.matchingGifts__I;
  }
  student__I?: boolean = undefined;
  studentIsSet: boolean = false;
  set student(v: undefined | boolean) {
    if (v !== undefined) {
      this.student__I = v;
      this.studentIsSet = true;
    } else {
      this.student__I = v || undefined;
      this.studentIsSet = false;
    }
    this.changeTracker = true;
  }
  get student() {
    return this.student__I;
  }
  school__I?: string = undefined;
  schoolIsSet: boolean = false;
  set school(v: undefined | string) {
    if (v !== undefined) {
      this.school__I = v;
      this.schoolIsSet = true;
    } else {
      this.school__I = v || undefined;
      this.schoolIsSet = false;
    }
    this.changeTracker = true;
  }
  get school() {
    return this.school__I;
  }
  military__I?: string = undefined;
  militaryIsSet: boolean = false;
  set military(v: undefined | string) {
    if (v !== undefined) {
      this.military__I = v;
      this.militaryIsSet = true;
    } else {
      this.military__I = v || undefined;
      this.militaryIsSet = false;
    }
    this.changeTracker = true;
  }
  get military() {
    return this.military__I;
  }
  reducedLunch__I?: boolean = undefined;
  reducedLunchIsSet: boolean = false;
  set reducedLunch(v: undefined | boolean) {
    if (v !== undefined) {
      this.reducedLunch__I = v;
      this.reducedLunchIsSet = true;
    } else {
      this.reducedLunch__I = v || undefined;
      this.reducedLunchIsSet = false;
    }
    this.changeTracker = true;
  }
  get reducedLunch() {
    return this.reducedLunch__I;
  }
  previousMember__I?: boolean = undefined;
  previousMemberIsSet: boolean = false;
  set previousMember(v: undefined | boolean) {
    if (v !== undefined) {
      this.previousMember__I = v;
      this.previousMemberIsSet = true;
    } else {
      this.previousMember__I = v || undefined;
      this.previousMemberIsSet = false;
    }
    this.changeTracker = true;
  }
  get previousMember() {
    return this.previousMember__I;
  }
  swimProof__I?: SwimProof = undefined;
  swimProofIsSet: boolean = false;
  set swimProof(v: undefined | SwimProof) {
    if (v !== undefined) {
      this.swimProof__I = v;
      this.swimProofIsSet = true;
    } else {
      this.swimProof__I = v || undefined;
      this.swimProofIsSet = false;
    }
    this.changeTracker = true;
  }
  get swimProof() {
    return this.swimProof__I;
  }
  dob__I?: Date = undefined;
  dobIsSet: boolean = false;
  set dob(v: undefined | Date) {
    if (v !== undefined) {
      this.dob__I = v;
      this.dobIsSet = true;
    } else {
      this.dob__I = v || undefined;
      this.dobIsSet = false;
    }
    this.changeTracker = true;
  }
  get dob() {
    return this.dob__I;
  }
  dobVerified__I?: boolean = undefined;
  dobVerifiedIsSet: boolean = false;
  set dobVerified(v: undefined | boolean) {
    if (v !== undefined) {
      this.dobVerified__I = v;
      this.dobVerifiedIsSet = true;
    } else {
      this.dobVerified__I = v || undefined;
      this.dobVerifiedIsSet = false;
    }
    this.changeTracker = true;
  }
  get dobVerified() {
    return this.dobVerified__I;
  }
  stripeCustomerId__I?: string = undefined;
  stripeCustomerIdIsSet: boolean = false;
  set stripeCustomerId(v: undefined | string) {
    if (v !== undefined) {
      this.stripeCustomerId__I = v;
      this.stripeCustomerIdIsSet = true;
    } else {
      this.stripeCustomerId__I = v || undefined;
      this.stripeCustomerIdIsSet = false;
    }
    this.changeTracker = true;
  }
  get stripeCustomerId() {
    return this.stripeCustomerId__I;
  }
  temp__I?: string = undefined;
  tempIsSet: boolean = false;
  set temp(v: undefined | string) {
    if (v !== undefined) {
      this.temp__I = v;
      this.tempIsSet = true;
    } else {
      this.temp__I = v || undefined;
      this.tempIsSet = true;
    }
    this.changeTracker = true;
  }
  get temp() {
    return this.temp__I;
  }
  referrals__I?: PersonReferralDTOTracked[] = undefined;
  referralsIsSet: boolean = false;
  set referrals(v: undefined | PersonReferralDTOTracked[]) {
    if (v !== undefined) {
      this.referrals__I = v;
      this.referralsIsSet = true;
    } else {
      this.referrals__I = v || undefined;
      this.referralsIsSet = false;
    }
    this.changeTracker = true;
  }
  get referrals() {
    return this.referrals__I;
  }
  phones__I?: PhoneDTOTracked[] = undefined;
  phonesIsSet: boolean = false;
  set phones(v: undefined | PhoneDTOTracked[]) {
    if (v !== undefined) {
      this.phones__I = v;
      this.phonesIsSet = true;
    } else {
      this.phones__I = v || undefined;
      this.phonesIsSet = false;
    }
    this.changeTracker = true;
  }
  get phones() {
    return this.phones__I;
  }
  addresses__I?: AddressDTOTracked[] = undefined;
  addressesIsSet: boolean = false;
  set addresses(v: undefined | AddressDTOTracked[]) {
    if (v !== undefined) {
      this.addresses__I = v;
      this.addressesIsSet = true;
    } else {
      this.addresses__I = v || undefined;
      this.addressesIsSet = false;
    }
    this.changeTracker = true;
  }
  get addresses() {
    return this.addresses__I;
  }
  isLocked__I?: boolean = undefined;
  isLockedIsSet: boolean = false;
  set isLocked(v: undefined | boolean) {
    if (v !== undefined) {
      this.isLocked__I = v;
      this.isLockedIsSet = true;
    } else {
      this.isLocked__I = v || undefined;
      this.isLockedIsSet = false;
    }
    this.changeTracker = true;
  }
  get isLocked() {
    return this.isLocked__I;
  }
  currentDamageWaivers__I?: DamageWaiverDTOTracked[] = undefined;
  currentDamageWaiversIsSet: boolean = false;
  set currentDamageWaivers(v: undefined | DamageWaiverDTOTracked[]) {
    if (v !== undefined) {
      this.currentDamageWaivers__I = v;
      this.currentDamageWaiversIsSet = true;
    } else {
      this.currentDamageWaivers__I = v || undefined;
      this.currentDamageWaiversIsSet = false;
    }
    this.changeTracker = true;
  }
  get currentDamageWaivers() {
    return this.currentDamageWaivers__I;
  }
  currentMemberships__I?: MembershipDTOTracked[] = undefined;
  currentMembershipsIsSet: boolean = false;
  set currentMemberships(v: undefined | MembershipDTOTracked[]) {
    if (v !== undefined) {
      this.currentMemberships__I = v;
      this.currentMembershipsIsSet = true;
    } else {
      this.currentMemberships__I = v || undefined;
      this.currentMembershipsIsSet = false;
    }
    this.changeTracker = true;
  }
  get currentMemberships() {
    return this.currentMemberships__I;
  }
  currentCards__I?: CardDTOTracked[] = undefined;
  currentCardsIsSet: boolean = false;
  set currentCards(v: undefined | CardDTOTracked[]) {
    if (v !== undefined) {
      this.currentCards__I = v;
      this.currentCardsIsSet = true;
    } else {
      this.currentCards__I = v || undefined;
      this.currentCardsIsSet = false;
    }
    this.changeTracker = true;
  }
  get currentCards() {
    return this.currentCards__I;
  }
  emergencyContacts__I?: PersonPublicRelatedDTOTracked[] = undefined;
  emergencyContactsIsSet: boolean = false;
  set emergencyContacts(v: undefined | PersonPublicRelatedDTOTracked[]) {
    if (v !== undefined) {
      this.emergencyContacts__I = v;
      this.emergencyContactsIsSet = true;
    } else {
      this.emergencyContacts__I = v || undefined;
      this.emergencyContactsIsSet = false;
    }
    this.changeTracker = true;
  }
  get emergencyContacts() {
    return this.emergencyContacts__I;
  }
  relationId__I?: number = undefined;

  get relationIdIsSet() {
    return this.relationId !== undefined;
  }
  set relationIdIsSet(v: boolean) {}
  set relationId(v: undefined | number) {
    if (v !== undefined) {
      this.relationId__I = v;
      this.relationIdIsSet = true;
    } else {
      this.relationId__I = v || undefined;
      this.relationIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get relationId() {
    return this.relationId__I;
  }
  isPrimary__I?: boolean = undefined;
  isPrimaryIsSet: boolean = false;
  set isPrimary(v: undefined | boolean) {
    if (v !== undefined) {
      this.isPrimary__I = v;
      this.isPrimaryIsSet = true;
    } else {
      this.isPrimary__I = v || undefined;
      this.isPrimaryIsSet = false;
    }
    this.changeTracker = true;
  }
  get isPrimary() {
    return this.isPrimary__I;
  }
  aTitleOverride__I?: string = undefined;
  aTitleOverrideIsSet: boolean = false;
  set aTitleOverride(v: undefined | string) {
    if (v !== undefined) {
      this.aTitleOverride__I = v;
      this.aTitleOverrideIsSet = true;
    } else {
      this.aTitleOverride__I = v || undefined;
      this.aTitleOverrideIsSet = false;
    }
    this.changeTracker = true;
  }
  get aTitleOverride() {
    return this.aTitleOverride__I;
  }
  bTitleOverride__I?: string = undefined;
  bTitleOverrideIsSet: boolean = false;
  set bTitleOverride(v: undefined | string) {
    if (v !== undefined) {
      this.bTitleOverride__I = v;
      this.bTitleOverrideIsSet = true;
    } else {
      this.bTitleOverride__I = v || undefined;
      this.bTitleOverrideIsSet = false;
    }
    this.changeTracker = true;
  }
  get bTitleOverride() {
    return this.bTitleOverride__I;
  }
  relationTypeId__I?: PersonRelationType = undefined;
  relationTypeIdIsSet: boolean = false;
  set relationTypeId(v: undefined | PersonRelationType) {
    if (v !== undefined) {
      this.relationTypeId__I = v;
      this.relationTypeIdIsSet = true;
    } else {
      this.relationTypeId__I = v || undefined;
      this.relationTypeIdIsSet = false;
    }
    this.changeTracker = true;
  }
  get relationTypeId() {
    return this.relationTypeId__I;
  }
  aTitle__I?: string = undefined;
  aTitleIsSet: boolean = false;
  set aTitle(v: undefined | string) {
    if (v !== undefined) {
      this.aTitle__I = v;
      this.aTitleIsSet = true;
    } else {
      this.aTitle__I = v || undefined;
      this.aTitleIsSet = false;
    }
    this.changeTracker = true;
  }
  get aTitle() {
    return this.aTitle__I;
  }
  bTitle__I?: string = undefined;
  bTitleIsSet: boolean = false;
  set bTitle(v: undefined | string) {
    if (v !== undefined) {
      this.bTitle__I = v;
      this.bTitleIsSet = true;
    } else {
      this.bTitle__I = v || undefined;
      this.bTitleIsSet = false;
    }
    this.changeTracker = true;
  }
  get bTitle() {
    return this.bTitle__I;
  }
  isDeleted__I?: boolean = undefined;
  isDeletedIsSet: boolean = false;
  set isDeleted(v: undefined | boolean) {
    if (v !== undefined) {
      this.isDeleted__I = v;
      this.isDeletedIsSet = true;
    } else {
      this.isDeleted__I = v || undefined;
      this.isDeletedIsSet = false;
    }
    this.changeTracker = true;
  }
  get isDeleted() {
    return this.isDeleted__I;
  }
  isNew__I?: boolean = undefined;
  isNewIsSet: boolean = false;
  set isNew(v: undefined | boolean) {
    if (v !== undefined) {
      this.isNew__I = v;
      this.isNewIsSet = true;
    } else {
      this.isNew__I = v || undefined;
      this.isNewIsSet = false;
    }
    this.changeTracker = true;
  }
  get isNew() {
    return this.isNew__I;
  }
  constructor(config?: PersonPublicChildDTOOptional, options?: AssignOptions) {
    super(config, options);
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    if (this.assignIdIsSet == true && other?.assignIdIsSet == true)
      return this.assignId == other.assignId;
    if (this.relationIdIsSet == true && other?.relationIdIsSet == true)
      return this.relationId == other.relationId;

    return this == other;
  }
  setIds() {
    if (this.anySet() && !!this.assignId) {
      this.assignIdIsSet = true;
    }

    this.referrals?.forEach((a) => a.setIds());

    this.phones?.forEach((a) => a.setIds());

    this.addresses?.forEach((a) => a.setIds());

    this.currentDamageWaivers?.forEach((a) => a.setIds());

    this.currentMemberships?.forEach((a) => a.setIds());

    this.currentCards?.forEach((a) => a.setIds());

    this.emergencyContacts?.forEach((a) => a.setIds());
    if (this.anySet() && !!this.relationId) {
      this.relationIdIsSet = true;
    }
  }
  assignFrom(
    config: PersonPublicChildDTOOptional,
    options?: AssignOptions,
  ): PersonPublicChildDTOTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.assignId && this.assignIdApplyFilter(optionsRequired.filter)) {
      this.assignId = config.assignId;
      if (optionsRequired.unassign) this.assignIdIsSet = false;
      else this.assignIdIsSet = true;
    }
    if (config.prefix && this.prefixApplyFilter(optionsRequired.filter)) {
      this.prefix = config.prefix;
      if (optionsRequired.unassign) this.prefixIsSet = false;
      else this.prefixIsSet = true;
    }
    if (config.first && this.firstApplyFilter(optionsRequired.filter)) {
      this.first = config.first;
      if (optionsRequired.unassign) this.firstIsSet = false;
      else this.firstIsSet = true;
    }
    if (config.middle && this.middleApplyFilter(optionsRequired.filter)) {
      this.middle = config.middle;
      if (optionsRequired.unassign) this.middleIsSet = false;
      else this.middleIsSet = true;
    }
    if (config.last && this.lastApplyFilter(optionsRequired.filter)) {
      this.last = config.last;
      if (optionsRequired.unassign) this.lastIsSet = false;
      else this.lastIsSet = true;
    }
    if (config.suffix && this.suffixApplyFilter(optionsRequired.filter)) {
      this.suffix = config.suffix;
      if (optionsRequired.unassign) this.suffixIsSet = false;
      else this.suffixIsSet = true;
    }
    if (config.preferred && this.preferredApplyFilter(optionsRequired.filter)) {
      this.preferred = config.preferred;
      if (optionsRequired.unassign) this.preferredIsSet = false;
      else this.preferredIsSet = true;
    }
    if (
      config.organization &&
      this.organizationApplyFilter(optionsRequired.filter)
    ) {
      this.organization = config.organization;
      if (optionsRequired.unassign) this.organizationIsSet = false;
      else this.organizationIsSet = true;
    }
    if (config.email && this.emailApplyFilter(optionsRequired.filter)) {
      this.email = config.email;
      if (optionsRequired.unassign) this.emailIsSet = false;
      else this.emailIsSet = true;
    }
    if (
      config.allowSignouts &&
      this.allowSignoutsApplyFilter(optionsRequired.filter)
    ) {
      this.allowSignouts = config.allowSignouts;
      if (optionsRequired.unassign) this.allowSignoutsIsSet = false;
      else this.allowSignoutsIsSet = true;
    }
    if (
      config.personType &&
      this.personTypeApplyFilter(optionsRequired.filter)
    ) {
      this.personType = config.personType;
      if (optionsRequired.unassign) this.personTypeIsSet = false;
      else this.personTypeIsSet = true;
    }
    if (config.allergies && this.allergiesApplyFilter(optionsRequired.filter)) {
      this.allergies = config.allergies;
      if (optionsRequired.unassign) this.allergiesIsSet = false;
      else this.allergiesIsSet = true;
    }
    if (
      config.medications &&
      this.medicationsApplyFilter(optionsRequired.filter)
    ) {
      this.medications = config.medications;
      if (optionsRequired.unassign) this.medicationsIsSet = false;
      else this.medicationsIsSet = true;
    }
    if (
      config.specialNeeds &&
      this.specialNeedsApplyFilter(optionsRequired.filter)
    ) {
      this.specialNeeds = config.specialNeeds;
      if (optionsRequired.unassign) this.specialNeedsIsSet = false;
      else this.specialNeedsIsSet = true;
    }
    if (config.gender && this.genderApplyFilter(optionsRequired.filter)) {
      this.gender = config.gender;
      if (optionsRequired.unassign) this.genderIsSet = false;
      else this.genderIsSet = true;
    }
    if (
      config.occupation &&
      this.occupationApplyFilter(optionsRequired.filter)
    ) {
      this.occupation = config.occupation;
      if (optionsRequired.unassign) this.occupationIsSet = false;
      else this.occupationIsSet = true;
    }
    if (
      config.citizenship &&
      this.citizenshipApplyFilter(optionsRequired.filter)
    ) {
      this.citizenship = config.citizenship;
      if (optionsRequired.unassign) this.citizenshipIsSet = false;
      else this.citizenshipIsSet = true;
    }
    if (config.ethnicity && this.ethnicityApplyFilter(optionsRequired.filter)) {
      this.ethnicity = config.ethnicity;
      if (optionsRequired.unassign) this.ethnicityIsSet = false;
      else this.ethnicityIsSet = true;
    }
    if (config.language && this.languageApplyFilter(optionsRequired.filter)) {
      this.language = config.language;
      if (optionsRequired.unassign) this.languageIsSet = false;
      else this.languageIsSet = true;
    }
    if (
      config.matchingGifts &&
      this.matchingGiftsApplyFilter(optionsRequired.filter)
    ) {
      this.matchingGifts = config.matchingGifts;
      if (optionsRequired.unassign) this.matchingGiftsIsSet = false;
      else this.matchingGiftsIsSet = true;
    }
    if (config.student && this.studentApplyFilter(optionsRequired.filter)) {
      this.student = config.student;
      if (optionsRequired.unassign) this.studentIsSet = false;
      else this.studentIsSet = true;
    }
    if (config.school && this.schoolApplyFilter(optionsRequired.filter)) {
      this.school = config.school;
      if (optionsRequired.unassign) this.schoolIsSet = false;
      else this.schoolIsSet = true;
    }
    if (config.military && this.militaryApplyFilter(optionsRequired.filter)) {
      this.military = config.military;
      if (optionsRequired.unassign) this.militaryIsSet = false;
      else this.militaryIsSet = true;
    }
    if (
      config.reducedLunch &&
      this.reducedLunchApplyFilter(optionsRequired.filter)
    ) {
      this.reducedLunch = config.reducedLunch;
      if (optionsRequired.unassign) this.reducedLunchIsSet = false;
      else this.reducedLunchIsSet = true;
    }
    if (
      config.previousMember &&
      this.previousMemberApplyFilter(optionsRequired.filter)
    ) {
      this.previousMember = config.previousMember;
      if (optionsRequired.unassign) this.previousMemberIsSet = false;
      else this.previousMemberIsSet = true;
    }
    if (config.swimProof && this.swimProofApplyFilter(optionsRequired.filter)) {
      this.swimProof = config.swimProof;
      if (optionsRequired.unassign) this.swimProofIsSet = false;
      else this.swimProofIsSet = true;
    }
    if (config.dob && this.dobApplyFilter(optionsRequired.filter)) {
      this.dob = config.dob;
      if (optionsRequired.unassign) this.dobIsSet = false;
      else this.dobIsSet = true;
    }
    if (
      config.dobVerified &&
      this.dobVerifiedApplyFilter(optionsRequired.filter)
    ) {
      this.dobVerified = config.dobVerified;
      if (optionsRequired.unassign) this.dobVerifiedIsSet = false;
      else this.dobVerifiedIsSet = true;
    }
    if (
      config.stripeCustomerId &&
      this.stripeCustomerIdApplyFilter(optionsRequired.filter)
    ) {
      this.stripeCustomerId = config.stripeCustomerId;
      if (optionsRequired.unassign) this.stripeCustomerIdIsSet = false;
      else this.stripeCustomerIdIsSet = true;
    }
    if (config.temp && this.tempApplyFilter(optionsRequired.filter)) {
      this.temp = config.temp;
      if (optionsRequired.unassign) this.tempIsSet = false;
      else this.tempIsSet = true;
    }
    if (config.referrals && this.referralsApplyFilter(optionsRequired.filter)) {
      this.referrals = config.referrals?.map(
        (a) => new PersonReferralDTOTracked(a, options),
      );
      if (optionsRequired.unassign) this.referralsIsSet = false;
      else this.referralsIsSet = true;
    }
    if (config.phones && this.phonesApplyFilter(optionsRequired.filter)) {
      this.phones = config.phones?.map((a) => new PhoneDTOTracked(a, options));
      if (optionsRequired.unassign) this.phonesIsSet = false;
      else this.phonesIsSet = true;
    }
    if (config.addresses && this.addressesApplyFilter(optionsRequired.filter)) {
      this.addresses = config.addresses?.map(
        (a) => new AddressDTOTracked(a, options),
      );
      if (optionsRequired.unassign) this.addressesIsSet = false;
      else this.addressesIsSet = true;
    }
    if (config.isLocked && this.isLockedApplyFilter(optionsRequired.filter)) {
      this.isLocked = config.isLocked;
      if (optionsRequired.unassign) this.isLockedIsSet = false;
      else this.isLockedIsSet = true;
    }
    if (
      config.currentDamageWaivers &&
      this.currentDamageWaiversApplyFilter(optionsRequired.filter)
    ) {
      this.currentDamageWaivers = config.currentDamageWaivers?.map(
        (a) => new DamageWaiverDTOTracked(a, options),
      );
      if (optionsRequired.unassign) this.currentDamageWaiversIsSet = false;
      else this.currentDamageWaiversIsSet = true;
    }
    if (
      config.currentMemberships &&
      this.currentMembershipsApplyFilter(optionsRequired.filter)
    ) {
      this.currentMemberships = config.currentMemberships?.map(
        (a) => new MembershipDTOTracked(a, options),
      );
      if (optionsRequired.unassign) this.currentMembershipsIsSet = false;
      else this.currentMembershipsIsSet = true;
    }
    if (
      config.currentCards &&
      this.currentCardsApplyFilter(optionsRequired.filter)
    ) {
      this.currentCards = config.currentCards?.map(
        (a) => new CardDTOTracked(a, options),
      );
      if (optionsRequired.unassign) this.currentCardsIsSet = false;
      else this.currentCardsIsSet = true;
    }
    if (
      config.emergencyContacts &&
      this.emergencyContactsApplyFilter(optionsRequired.filter)
    ) {
      this.emergencyContacts = config.emergencyContacts?.map(
        (a) => new PersonPublicRelatedDTOTracked(a, options),
      );
      if (optionsRequired.unassign) this.emergencyContactsIsSet = false;
      else this.emergencyContactsIsSet = true;
    }
    if (
      config.relationId &&
      this.relationIdApplyFilter(optionsRequired.filter)
    ) {
      this.relationId = config.relationId;
      if (optionsRequired.unassign) this.relationIdIsSet = false;
      else this.relationIdIsSet = true;
    }
    if (config.isPrimary && this.isPrimaryApplyFilter(optionsRequired.filter)) {
      this.isPrimary = config.isPrimary;
      if (optionsRequired.unassign) this.isPrimaryIsSet = false;
      else this.isPrimaryIsSet = true;
    }
    if (
      config.aTitleOverride &&
      this.aTitleOverrideApplyFilter(optionsRequired.filter)
    ) {
      this.aTitleOverride = config.aTitleOverride;
      if (optionsRequired.unassign) this.aTitleOverrideIsSet = false;
      else this.aTitleOverrideIsSet = true;
    }
    if (
      config.bTitleOverride &&
      this.bTitleOverrideApplyFilter(optionsRequired.filter)
    ) {
      this.bTitleOverride = config.bTitleOverride;
      if (optionsRequired.unassign) this.bTitleOverrideIsSet = false;
      else this.bTitleOverrideIsSet = true;
    }
    if (
      config.relationTypeId &&
      this.relationTypeIdApplyFilter(optionsRequired.filter)
    ) {
      this.relationTypeId = config.relationTypeId;
      if (optionsRequired.unassign) this.relationTypeIdIsSet = false;
      else this.relationTypeIdIsSet = true;
    }
    if (config.aTitle && this.aTitleApplyFilter(optionsRequired.filter)) {
      this.aTitle = config.aTitle;
      if (optionsRequired.unassign) this.aTitleIsSet = false;
      else this.aTitleIsSet = true;
    }
    if (config.bTitle && this.bTitleApplyFilter(optionsRequired.filter)) {
      this.bTitle = config.bTitle;
      if (optionsRequired.unassign) this.bTitleIsSet = false;
      else this.bTitleIsSet = true;
    }
    if (config.isDeleted && this.isDeletedApplyFilter(optionsRequired.filter)) {
      this.isDeleted = config.isDeleted;
      if (optionsRequired.unassign) this.isDeletedIsSet = false;
      else this.isDeletedIsSet = true;
    }
    if (config.isNew && this.isNewApplyFilter(optionsRequired.filter)) {
      this.isNew = config.isNew;
      if (optionsRequired.unassign) this.isNewIsSet = false;
      else this.isNewIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): PersonPublicChildDTOTrackedI {
    const cloned = {} as PersonPublicChildDTOTrackedI;
    if (
      this.assignIdIsSetDeep() &&
      this.assignIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.assignIdIsSet = true;
      cloned.assignId = this.assignId;
    } else {
      //cloned.assignIdIsSet = false
    }
    if (
      this.prefixIsSetDeep() &&
      this.prefixApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.prefixIsSet = true;
      cloned.prefix = this.prefix;
    } else {
      //cloned.prefixIsSet = false
    }
    if (
      this.firstIsSetDeep() &&
      this.firstApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.firstIsSet = true;
      cloned.first = this.first;
    } else {
      //cloned.firstIsSet = false
    }
    if (
      this.middleIsSetDeep() &&
      this.middleApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.middleIsSet = true;
      cloned.middle = this.middle;
    } else {
      //cloned.middleIsSet = false
    }
    if (
      this.lastIsSetDeep() &&
      this.lastApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.lastIsSet = true;
      cloned.last = this.last;
    } else {
      //cloned.lastIsSet = false
    }
    if (
      this.suffixIsSetDeep() &&
      this.suffixApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.suffixIsSet = true;
      cloned.suffix = this.suffix;
    } else {
      //cloned.suffixIsSet = false
    }
    if (
      this.preferredIsSetDeep() &&
      this.preferredApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.preferredIsSet = true;
      cloned.preferred = this.preferred;
    } else {
      //cloned.preferredIsSet = false
    }
    if (
      this.organizationIsSetDeep() &&
      this.organizationApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.organizationIsSet = true;
      cloned.organization = this.organization;
    } else {
      //cloned.organizationIsSet = false
    }
    if (
      this.emailIsSetDeep() &&
      this.emailApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.emailIsSet = true;
      cloned.email = this.email;
    } else {
      //cloned.emailIsSet = false
    }
    if (
      this.allowSignoutsIsSetDeep() &&
      this.allowSignoutsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.allowSignoutsIsSet = true;
      cloned.allowSignouts = this.allowSignouts;
    } else {
      //cloned.allowSignoutsIsSet = false
    }
    if (
      this.personTypeIsSetDeep() &&
      this.personTypeApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.personTypeIsSet = true;
      cloned.personType = this.personType;
    } else {
      //cloned.personTypeIsSet = false
    }
    if (
      this.allergiesIsSetDeep() &&
      this.allergiesApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.allergiesIsSet = true;
      cloned.allergies = this.allergies;
    } else {
      //cloned.allergiesIsSet = false
    }
    if (
      this.medicationsIsSetDeep() &&
      this.medicationsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.medicationsIsSet = true;
      cloned.medications = this.medications;
    } else {
      //cloned.medicationsIsSet = false
    }
    if (
      this.specialNeedsIsSetDeep() &&
      this.specialNeedsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.specialNeedsIsSet = true;
      cloned.specialNeeds = this.specialNeeds;
    } else {
      //cloned.specialNeedsIsSet = false
    }
    if (
      this.genderIsSetDeep() &&
      this.genderApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.genderIsSet = true;
      cloned.gender = this.gender;
    } else {
      //cloned.genderIsSet = false
    }
    if (
      this.occupationIsSetDeep() &&
      this.occupationApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.occupationIsSet = true;
      cloned.occupation = this.occupation;
    } else {
      //cloned.occupationIsSet = false
    }
    if (
      this.citizenshipIsSetDeep() &&
      this.citizenshipApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.citizenshipIsSet = true;
      cloned.citizenship = this.citizenship;
    } else {
      //cloned.citizenshipIsSet = false
    }
    if (
      this.ethnicityIsSetDeep() &&
      this.ethnicityApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.ethnicityIsSet = true;
      cloned.ethnicity = this.ethnicity;
    } else {
      //cloned.ethnicityIsSet = false
    }
    if (
      this.languageIsSetDeep() &&
      this.languageApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.languageIsSet = true;
      cloned.language = this.language;
    } else {
      //cloned.languageIsSet = false
    }
    if (
      this.matchingGiftsIsSetDeep() &&
      this.matchingGiftsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.matchingGiftsIsSet = true;
      cloned.matchingGifts = this.matchingGifts;
    } else {
      //cloned.matchingGiftsIsSet = false
    }
    if (
      this.studentIsSetDeep() &&
      this.studentApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.studentIsSet = true;
      cloned.student = this.student;
    } else {
      //cloned.studentIsSet = false
    }
    if (
      this.schoolIsSetDeep() &&
      this.schoolApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.schoolIsSet = true;
      cloned.school = this.school;
    } else {
      //cloned.schoolIsSet = false
    }
    if (
      this.militaryIsSetDeep() &&
      this.militaryApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.militaryIsSet = true;
      cloned.military = this.military;
    } else {
      //cloned.militaryIsSet = false
    }
    if (
      this.reducedLunchIsSetDeep() &&
      this.reducedLunchApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.reducedLunchIsSet = true;
      cloned.reducedLunch = this.reducedLunch;
    } else {
      //cloned.reducedLunchIsSet = false
    }
    if (
      this.previousMemberIsSetDeep() &&
      this.previousMemberApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.previousMemberIsSet = true;
      cloned.previousMember = this.previousMember;
    } else {
      //cloned.previousMemberIsSet = false
    }
    if (
      this.swimProofIsSetDeep() &&
      this.swimProofApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.swimProofIsSet = true;
      cloned.swimProof = this.swimProof;
    } else {
      //cloned.swimProofIsSet = false
    }
    if (
      this.dobIsSetDeep() &&
      this.dobApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.dobIsSet = true;
      cloned.dob = this.dob;
    } else {
      //cloned.dobIsSet = false
    }
    if (
      this.dobVerifiedIsSetDeep() &&
      this.dobVerifiedApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.dobVerifiedIsSet = true;
      cloned.dobVerified = this.dobVerified;
    } else {
      //cloned.dobVerifiedIsSet = false
    }
    if (
      this.stripeCustomerIdIsSetDeep() &&
      this.stripeCustomerIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.stripeCustomerIdIsSet = true;
      cloned.stripeCustomerId = this.stripeCustomerId;
    } else {
      //cloned.stripeCustomerIdIsSet = false
    }
    if (
      this.tempIsSetDeep() &&
      this.tempApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.tempIsSet = true;
      cloned.temp = this.temp;
    } else {
      //cloned.tempIsSet = false
    }
    if (
      this.referralsIsSetDeep((a, b) => !a.isPrimary || !b.isArray) &&
      this.referralsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.referralsIsSet = true;
      cloned.referrals = this.referrals
        ?.filter((a) => !a.shouldRemove(true))
        ?.map((a) => a.removeUnset(filter));
    } else {
      //cloned.referralsIsSet = false
    }
    if (
      this.phonesIsSetDeep((a, b) => !a.isPrimary || !b.isArray) &&
      this.phonesApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.phonesIsSet = true;
      cloned.phones = this.phones
        ?.filter((a) => !a.shouldRemove(true))
        ?.map((a) => a.removeUnset(filter));
    } else {
      //cloned.phonesIsSet = false
    }
    if (
      this.addressesIsSetDeep((a, b) => !a.isPrimary || !b.isArray) &&
      this.addressesApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.addressesIsSet = true;
      cloned.addresses = this.addresses
        ?.filter((a) => !a.shouldRemove(true))
        ?.map((a) => a.removeUnset(filter));
    } else {
      //cloned.addressesIsSet = false
    }
    if (
      this.isLockedIsSetDeep() &&
      this.isLockedApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isLockedIsSet = true;
      cloned.isLocked = this.isLocked;
    } else {
      //cloned.isLockedIsSet = false
    }
    if (
      this.currentDamageWaiversIsSetDeep(
        (a, b) => !a.isPrimary || !b.isArray,
      ) &&
      this.currentDamageWaiversApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.currentDamageWaiversIsSet = true;
      cloned.currentDamageWaivers = this.currentDamageWaivers
        ?.filter((a) => !a.shouldRemove(true))
        ?.map((a) => a.removeUnset(filter));
    } else {
      //cloned.currentDamageWaiversIsSet = false
    }
    if (
      this.currentMembershipsIsSetDeep((a, b) => !a.isPrimary || !b.isArray) &&
      this.currentMembershipsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.currentMembershipsIsSet = true;
      cloned.currentMemberships = this.currentMemberships
        ?.filter((a) => !a.shouldRemove(true))
        ?.map((a) => a.removeUnset(filter));
    } else {
      //cloned.currentMembershipsIsSet = false
    }
    if (
      this.currentCardsIsSetDeep((a, b) => !a.isPrimary || !b.isArray) &&
      this.currentCardsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.currentCardsIsSet = true;
      cloned.currentCards = this.currentCards
        ?.filter((a) => !a.shouldRemove(true))
        ?.map((a) => a.removeUnset(filter));
    } else {
      //cloned.currentCardsIsSet = false
    }
    if (
      this.emergencyContactsIsSetDeep((a, b) => !a.isPrimary || !b.isArray) &&
      this.emergencyContactsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.emergencyContactsIsSet = true;
      cloned.emergencyContacts = this.emergencyContacts
        ?.filter((a) => !a.shouldRemove(true))
        ?.map((a) => a.removeUnset(filter));
    } else {
      //cloned.emergencyContactsIsSet = false
    }
    if (
      this.relationIdIsSetDeep() &&
      this.relationIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.relationIdIsSet = true;
      cloned.relationId = this.relationId;
    } else {
      //cloned.relationIdIsSet = false
    }
    if (
      this.isPrimaryIsSetDeep() &&
      this.isPrimaryApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isPrimaryIsSet = true;
      cloned.isPrimary = this.isPrimary;
    } else {
      //cloned.isPrimaryIsSet = false
    }
    if (
      this.aTitleOverrideIsSetDeep() &&
      this.aTitleOverrideApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.aTitleOverrideIsSet = true;
      cloned.aTitleOverride = this.aTitleOverride;
    } else {
      //cloned.aTitleOverrideIsSet = false
    }
    if (
      this.bTitleOverrideIsSetDeep() &&
      this.bTitleOverrideApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.bTitleOverrideIsSet = true;
      cloned.bTitleOverride = this.bTitleOverride;
    } else {
      //cloned.bTitleOverrideIsSet = false
    }
    if (
      this.relationTypeIdIsSetDeep() &&
      this.relationTypeIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.relationTypeIdIsSet = true;
      cloned.relationTypeId = this.relationTypeId;
    } else {
      //cloned.relationTypeIdIsSet = false
    }
    if (
      this.aTitleIsSetDeep() &&
      this.aTitleApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.aTitleIsSet = true;
      cloned.aTitle = this.aTitle;
    } else {
      //cloned.aTitleIsSet = false
    }
    if (
      this.bTitleIsSetDeep() &&
      this.bTitleApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.bTitleIsSet = true;
      cloned.bTitle = this.bTitle;
    } else {
      //cloned.bTitleIsSet = false
    }
    if (
      this.isDeletedIsSetDeep() &&
      this.isDeletedApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isDeletedIsSet = true;
      cloned.isDeleted = this.isDeleted;
    } else {
      //cloned.isDeletedIsSet = false
    }
    if (
      this.isNewIsSetDeep() &&
      this.isNewApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isNewIsSet = true;
      cloned.isNew = this.isNew;
    } else {
      //cloned.isNewIsSet = false
    }
    if (!isDeleted(this) && !this.assignIdIsSet) updateIsNew(cloned, true);
    if (!isDeleted(this) && !this.relationIdIsSet) updateIsNew(cloned, true);
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): PersonPublicChildDTOTrackedI {
    if (!this.assignIdApplyFilter(filter)) this.assignIdIsSet = false;

    if (!this.prefixApplyFilter(filter)) this.prefixIsSet = false;

    if (!this.firstApplyFilter(filter)) this.firstIsSet = false;

    if (!this.middleApplyFilter(filter)) this.middleIsSet = false;

    if (!this.lastApplyFilter(filter)) this.lastIsSet = false;

    if (!this.suffixApplyFilter(filter)) this.suffixIsSet = false;

    if (!this.preferredApplyFilter(filter)) this.preferredIsSet = false;

    if (!this.organizationApplyFilter(filter)) this.organizationIsSet = false;

    if (!this.emailApplyFilter(filter)) this.emailIsSet = false;

    if (!this.allowSignoutsApplyFilter(filter)) this.allowSignoutsIsSet = false;

    if (!this.personTypeApplyFilter(filter)) this.personTypeIsSet = false;

    if (!this.allergiesApplyFilter(filter)) this.allergiesIsSet = false;

    if (!this.medicationsApplyFilter(filter)) this.medicationsIsSet = false;

    if (!this.specialNeedsApplyFilter(filter)) this.specialNeedsIsSet = false;

    if (!this.genderApplyFilter(filter)) this.genderIsSet = false;

    if (!this.occupationApplyFilter(filter)) this.occupationIsSet = false;

    if (!this.citizenshipApplyFilter(filter)) this.citizenshipIsSet = false;

    if (!this.ethnicityApplyFilter(filter)) this.ethnicityIsSet = false;

    if (!this.languageApplyFilter(filter)) this.languageIsSet = false;

    if (!this.matchingGiftsApplyFilter(filter)) this.matchingGiftsIsSet = false;

    if (!this.studentApplyFilter(filter)) this.studentIsSet = false;

    if (!this.schoolApplyFilter(filter)) this.schoolIsSet = false;

    if (!this.militaryApplyFilter(filter)) this.militaryIsSet = false;

    if (!this.reducedLunchApplyFilter(filter)) this.reducedLunchIsSet = false;

    if (!this.previousMemberApplyFilter(filter))
      this.previousMemberIsSet = false;

    if (!this.swimProofApplyFilter(filter)) this.swimProofIsSet = false;

    if (!this.dobApplyFilter(filter)) this.dobIsSet = false;

    if (!this.dobVerifiedApplyFilter(filter)) this.dobVerifiedIsSet = false;

    if (!this.stripeCustomerIdApplyFilter(filter))
      this.stripeCustomerIdIsSet = false;

    if (!this.tempApplyFilter(filter)) this.tempIsSet = false;

    if (!this.referralsApplyFilter(filter)) this.referralsIsSet = false;

    this.referrals?.forEach((a) => a.unassignAll(filter));
    if (!this.phonesApplyFilter(filter)) this.phonesIsSet = false;

    this.phones?.forEach((a) => a.unassignAll(filter));
    if (!this.addressesApplyFilter(filter)) this.addressesIsSet = false;

    this.addresses?.forEach((a) => a.unassignAll(filter));
    if (!this.isLockedApplyFilter(filter)) this.isLockedIsSet = false;

    if (!this.currentDamageWaiversApplyFilter(filter))
      this.currentDamageWaiversIsSet = false;

    this.currentDamageWaivers?.forEach((a) => a.unassignAll(filter));
    if (!this.currentMembershipsApplyFilter(filter))
      this.currentMembershipsIsSet = false;

    this.currentMemberships?.forEach((a) => a.unassignAll(filter));
    if (!this.currentCardsApplyFilter(filter)) this.currentCardsIsSet = false;

    this.currentCards?.forEach((a) => a.unassignAll(filter));
    if (!this.emergencyContactsApplyFilter(filter))
      this.emergencyContactsIsSet = false;

    this.emergencyContacts?.forEach((a) => a.unassignAll(filter));
    if (!this.relationIdApplyFilter(filter)) this.relationIdIsSet = false;

    if (!this.isPrimaryApplyFilter(filter)) this.isPrimaryIsSet = false;

    if (!this.aTitleOverrideApplyFilter(filter))
      this.aTitleOverrideIsSet = false;

    if (!this.bTitleOverrideApplyFilter(filter))
      this.bTitleOverrideIsSet = false;

    if (!this.relationTypeIdApplyFilter(filter))
      this.relationTypeIdIsSet = false;

    if (!this.aTitleApplyFilter(filter)) this.aTitleIsSet = false;

    if (!this.bTitleApplyFilter(filter)) this.bTitleIsSet = false;

    if (!this.isDeletedApplyFilter(filter)) this.isDeletedIsSet = false;

    if (!this.isNewApplyFilter(filter)) this.isNewIsSet = false;

    return this;
  }
  assignIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonPublicChildDTOMeta.assignId,
      PersonPublicChildDTOMeta,
      this.assignId,
      this,
    );
  }
  assignIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.assignIdIsSet && this.assignIdApplyFilter(filter)) return true;

    return false;
  }
  prefixApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonPublicChildDTOMeta.prefix,
      PersonPublicChildDTOMeta,
      this.prefix,
      this,
    );
  }
  prefixIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.prefixIsSet && this.prefixApplyFilter(filter)) return true;

    return false;
  }
  firstApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonPublicChildDTOMeta.first,
      PersonPublicChildDTOMeta,
      this.first,
      this,
    );
  }
  firstIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.firstIsSet && this.firstApplyFilter(filter)) return true;

    return false;
  }
  middleApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonPublicChildDTOMeta.middle,
      PersonPublicChildDTOMeta,
      this.middle,
      this,
    );
  }
  middleIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.middleIsSet && this.middleApplyFilter(filter)) return true;

    return false;
  }
  lastApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonPublicChildDTOMeta.last,
      PersonPublicChildDTOMeta,
      this.last,
      this,
    );
  }
  lastIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.lastIsSet && this.lastApplyFilter(filter)) return true;

    return false;
  }
  suffixApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonPublicChildDTOMeta.suffix,
      PersonPublicChildDTOMeta,
      this.suffix,
      this,
    );
  }
  suffixIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.suffixIsSet && this.suffixApplyFilter(filter)) return true;

    return false;
  }
  preferredApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonPublicChildDTOMeta.preferred,
      PersonPublicChildDTOMeta,
      this.preferred,
      this,
    );
  }
  preferredIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.preferredIsSet && this.preferredApplyFilter(filter)) return true;

    return false;
  }
  organizationApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonPublicChildDTOMeta.organization,
      PersonPublicChildDTOMeta,
      this.organization,
      this,
    );
  }
  organizationIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.organizationIsSet && this.organizationApplyFilter(filter))
      return true;

    return false;
  }
  emailApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonPublicChildDTOMeta.email,
      PersonPublicChildDTOMeta,
      this.email,
      this,
    );
  }
  emailIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.emailIsSet && this.emailApplyFilter(filter)) return true;

    return false;
  }
  allowSignoutsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonPublicChildDTOMeta.allowSignouts,
      PersonPublicChildDTOMeta,
      this.allowSignouts,
      this,
    );
  }
  allowSignoutsIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.allowSignoutsIsSet && this.allowSignoutsApplyFilter(filter))
      return true;

    return false;
  }
  personTypeApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonPublicChildDTOMeta.personType,
      PersonPublicChildDTOMeta,
      this.personType,
      this,
    );
  }
  personTypeIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.personTypeIsSet && this.personTypeApplyFilter(filter)) return true;

    return false;
  }
  allergiesApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonPublicChildDTOMeta.allergies,
      PersonPublicChildDTOMeta,
      this.allergies,
      this,
    );
  }
  allergiesIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.allergiesIsSet && this.allergiesApplyFilter(filter)) return true;

    return false;
  }
  medicationsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonPublicChildDTOMeta.medications,
      PersonPublicChildDTOMeta,
      this.medications,
      this,
    );
  }
  medicationsIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.medicationsIsSet && this.medicationsApplyFilter(filter))
      return true;

    return false;
  }
  specialNeedsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonPublicChildDTOMeta.specialNeeds,
      PersonPublicChildDTOMeta,
      this.specialNeeds,
      this,
    );
  }
  specialNeedsIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.specialNeedsIsSet && this.specialNeedsApplyFilter(filter))
      return true;

    return false;
  }
  genderApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonPublicChildDTOMeta.gender,
      PersonPublicChildDTOMeta,
      this.gender,
      this,
    );
  }
  genderIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.genderIsSet && this.genderApplyFilter(filter)) return true;

    return false;
  }
  occupationApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonPublicChildDTOMeta.occupation,
      PersonPublicChildDTOMeta,
      this.occupation,
      this,
    );
  }
  occupationIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.occupationIsSet && this.occupationApplyFilter(filter)) return true;

    return false;
  }
  citizenshipApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonPublicChildDTOMeta.citizenship,
      PersonPublicChildDTOMeta,
      this.citizenship,
      this,
    );
  }
  citizenshipIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.citizenshipIsSet && this.citizenshipApplyFilter(filter))
      return true;

    return false;
  }
  ethnicityApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonPublicChildDTOMeta.ethnicity,
      PersonPublicChildDTOMeta,
      this.ethnicity,
      this,
    );
  }
  ethnicityIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.ethnicityIsSet && this.ethnicityApplyFilter(filter)) return true;

    return false;
  }
  languageApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonPublicChildDTOMeta.language,
      PersonPublicChildDTOMeta,
      this.language,
      this,
    );
  }
  languageIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.languageIsSet && this.languageApplyFilter(filter)) return true;

    return false;
  }
  matchingGiftsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonPublicChildDTOMeta.matchingGifts,
      PersonPublicChildDTOMeta,
      this.matchingGifts,
      this,
    );
  }
  matchingGiftsIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.matchingGiftsIsSet && this.matchingGiftsApplyFilter(filter))
      return true;

    return false;
  }
  studentApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonPublicChildDTOMeta.student,
      PersonPublicChildDTOMeta,
      this.student,
      this,
    );
  }
  studentIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.studentIsSet && this.studentApplyFilter(filter)) return true;

    return false;
  }
  schoolApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonPublicChildDTOMeta.school,
      PersonPublicChildDTOMeta,
      this.school,
      this,
    );
  }
  schoolIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.schoolIsSet && this.schoolApplyFilter(filter)) return true;

    return false;
  }
  militaryApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonPublicChildDTOMeta.military,
      PersonPublicChildDTOMeta,
      this.military,
      this,
    );
  }
  militaryIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.militaryIsSet && this.militaryApplyFilter(filter)) return true;

    return false;
  }
  reducedLunchApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonPublicChildDTOMeta.reducedLunch,
      PersonPublicChildDTOMeta,
      this.reducedLunch,
      this,
    );
  }
  reducedLunchIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.reducedLunchIsSet && this.reducedLunchApplyFilter(filter))
      return true;

    return false;
  }
  previousMemberApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonPublicChildDTOMeta.previousMember,
      PersonPublicChildDTOMeta,
      this.previousMember,
      this,
    );
  }
  previousMemberIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.previousMemberIsSet && this.previousMemberApplyFilter(filter))
      return true;

    return false;
  }
  swimProofApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonPublicChildDTOMeta.swimProof,
      PersonPublicChildDTOMeta,
      this.swimProof,
      this,
    );
  }
  swimProofIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.swimProofIsSet && this.swimProofApplyFilter(filter)) return true;

    return false;
  }
  dobApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonPublicChildDTOMeta.dob,
      PersonPublicChildDTOMeta,
      this.dob,
      this,
    );
  }
  dobIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.dobIsSet && this.dobApplyFilter(filter)) return true;

    return false;
  }
  dobVerifiedApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonPublicChildDTOMeta.dobVerified,
      PersonPublicChildDTOMeta,
      this.dobVerified,
      this,
    );
  }
  dobVerifiedIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.dobVerifiedIsSet && this.dobVerifiedApplyFilter(filter))
      return true;

    return false;
  }
  stripeCustomerIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonPublicChildDTOMeta.stripeCustomerId,
      PersonPublicChildDTOMeta,
      this.stripeCustomerId,
      this,
    );
  }
  stripeCustomerIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.stripeCustomerIdIsSet && this.stripeCustomerIdApplyFilter(filter))
      return true;

    return false;
  }
  tempApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonPublicChildDTOMeta.temp,
      PersonPublicChildDTOMeta,
      this.temp,
      this,
    );
  }
  tempIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.tempIsSet && this.tempApplyFilter(filter)) return true;

    return false;
  }
  referralsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonPublicChildDTOMeta.referrals,
      PersonPublicChildDTOMeta,
      this.referrals,
      this,
    );
  }
  referralsIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.referralsIsSet && this.referralsApplyFilter(filter)) return true;

    return this.referrals?.find((a) => a.anySet(filter)) != undefined;
    return false;
  }
  phonesApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonPublicChildDTOMeta.phones,
      PersonPublicChildDTOMeta,
      this.phones,
      this,
    );
  }
  phonesIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.phonesIsSet && this.phonesApplyFilter(filter)) return true;

    return this.phones?.find((a) => a.anySet(filter)) != undefined;
    return false;
  }
  addressesApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonPublicChildDTOMeta.addresses,
      PersonPublicChildDTOMeta,
      this.addresses,
      this,
    );
  }
  addressesIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.addressesIsSet && this.addressesApplyFilter(filter)) return true;

    return this.addresses?.find((a) => a.anySet(filter)) != undefined;
    return false;
  }
  isLockedApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonPublicChildDTOMeta.isLocked,
      PersonPublicChildDTOMeta,
      this.isLocked,
      this,
    );
  }
  isLockedIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isLockedIsSet && this.isLockedApplyFilter(filter)) return true;

    return false;
  }
  currentDamageWaiversApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonPublicChildDTOMeta.currentDamageWaivers,
      PersonPublicChildDTOMeta,
      this.currentDamageWaivers,
      this,
    );
  }
  currentDamageWaiversIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.currentDamageWaiversIsSet &&
      this.currentDamageWaiversApplyFilter(filter)
    )
      return true;

    return (
      this.currentDamageWaivers?.find((a) => a.anySet(filter)) != undefined
    );
    return false;
  }
  currentMembershipsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonPublicChildDTOMeta.currentMemberships,
      PersonPublicChildDTOMeta,
      this.currentMemberships,
      this,
    );
  }
  currentMembershipsIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.currentMembershipsIsSet &&
      this.currentMembershipsApplyFilter(filter)
    )
      return true;

    return this.currentMemberships?.find((a) => a.anySet(filter)) != undefined;
    return false;
  }
  currentCardsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonPublicChildDTOMeta.currentCards,
      PersonPublicChildDTOMeta,
      this.currentCards,
      this,
    );
  }
  currentCardsIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.currentCardsIsSet && this.currentCardsApplyFilter(filter))
      return true;

    return this.currentCards?.find((a) => a.anySet(filter)) != undefined;
    return false;
  }
  emergencyContactsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonPublicChildDTOMeta.emergencyContacts,
      PersonPublicChildDTOMeta,
      this.emergencyContacts,
      this,
    );
  }
  emergencyContactsIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.emergencyContactsIsSet &&
      this.emergencyContactsApplyFilter(filter)
    )
      return true;

    return this.emergencyContacts?.find((a) => a.anySet(filter)) != undefined;
    return false;
  }
  relationIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonPublicChildDTOMeta.relationId,
      PersonPublicChildDTOMeta,
      this.relationId,
      this,
    );
  }
  relationIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.relationIdIsSet && this.relationIdApplyFilter(filter)) return true;

    return false;
  }
  isPrimaryApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonPublicChildDTOMeta.isPrimary,
      PersonPublicChildDTOMeta,
      this.isPrimary,
      this,
    );
  }
  isPrimaryIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isPrimaryIsSet && this.isPrimaryApplyFilter(filter)) return true;

    return false;
  }
  aTitleOverrideApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonPublicChildDTOMeta.aTitleOverride,
      PersonPublicChildDTOMeta,
      this.aTitleOverride,
      this,
    );
  }
  aTitleOverrideIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.aTitleOverrideIsSet && this.aTitleOverrideApplyFilter(filter))
      return true;

    return false;
  }
  bTitleOverrideApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonPublicChildDTOMeta.bTitleOverride,
      PersonPublicChildDTOMeta,
      this.bTitleOverride,
      this,
    );
  }
  bTitleOverrideIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.bTitleOverrideIsSet && this.bTitleOverrideApplyFilter(filter))
      return true;

    return false;
  }
  relationTypeIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonPublicChildDTOMeta.relationTypeId,
      PersonPublicChildDTOMeta,
      this.relationTypeId,
      this,
    );
  }
  relationTypeIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.relationTypeIdIsSet && this.relationTypeIdApplyFilter(filter))
      return true;

    return false;
  }
  aTitleApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonPublicChildDTOMeta.aTitle,
      PersonPublicChildDTOMeta,
      this.aTitle,
      this,
    );
  }
  aTitleIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.aTitleIsSet && this.aTitleApplyFilter(filter)) return true;

    return false;
  }
  bTitleApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonPublicChildDTOMeta.bTitle,
      PersonPublicChildDTOMeta,
      this.bTitle,
      this,
    );
  }
  bTitleIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.bTitleIsSet && this.bTitleApplyFilter(filter)) return true;

    return false;
  }
  isDeletedApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonPublicChildDTOMeta.isDeleted,
      PersonPublicChildDTOMeta,
      this.isDeleted,
      this,
    );
  }
  isDeletedIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isDeletedIsSet && this.isDeletedApplyFilter(filter)) return true;

    return false;
  }
  isNewApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonPublicChildDTOMeta.isNew,
      PersonPublicChildDTOMeta,
      this.isNew,
      this,
    );
  }
  isNewIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isNewIsSet && this.isNewApplyFilter(filter)) return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.assignIdIsSetDeep(filter)) return true;
    if (this.prefixIsSetDeep(filter)) return true;
    if (this.firstIsSetDeep(filter)) return true;
    if (this.middleIsSetDeep(filter)) return true;
    if (this.lastIsSetDeep(filter)) return true;
    if (this.suffixIsSetDeep(filter)) return true;
    if (this.preferredIsSetDeep(filter)) return true;
    if (this.organizationIsSetDeep(filter)) return true;
    if (this.emailIsSetDeep(filter)) return true;
    if (this.allowSignoutsIsSetDeep(filter)) return true;
    if (this.personTypeIsSetDeep(filter)) return true;
    if (this.allergiesIsSetDeep(filter)) return true;
    if (this.medicationsIsSetDeep(filter)) return true;
    if (this.specialNeedsIsSetDeep(filter)) return true;
    if (this.genderIsSetDeep(filter)) return true;
    if (this.occupationIsSetDeep(filter)) return true;
    if (this.citizenshipIsSetDeep(filter)) return true;
    if (this.ethnicityIsSetDeep(filter)) return true;
    if (this.languageIsSetDeep(filter)) return true;
    if (this.matchingGiftsIsSetDeep(filter)) return true;
    if (this.studentIsSetDeep(filter)) return true;
    if (this.schoolIsSetDeep(filter)) return true;
    if (this.militaryIsSetDeep(filter)) return true;
    if (this.reducedLunchIsSetDeep(filter)) return true;
    if (this.previousMemberIsSetDeep(filter)) return true;
    if (this.swimProofIsSetDeep(filter)) return true;
    if (this.dobIsSetDeep(filter)) return true;
    if (this.dobVerifiedIsSetDeep(filter)) return true;
    if (this.stripeCustomerIdIsSetDeep(filter)) return true;
    if (this.tempIsSetDeep(filter)) return true;
    if (this.referralsIsSetDeep(filter)) return true;
    if (this.phonesIsSetDeep(filter)) return true;
    if (this.addressesIsSetDeep(filter)) return true;
    if (this.isLockedIsSetDeep(filter)) return true;
    if (this.currentDamageWaiversIsSetDeep(filter)) return true;
    if (this.currentMembershipsIsSetDeep(filter)) return true;
    if (this.currentCardsIsSetDeep(filter)) return true;
    if (this.emergencyContactsIsSetDeep(filter)) return true;
    if (this.relationIdIsSetDeep(filter)) return true;
    if (this.isPrimaryIsSetDeep(filter)) return true;
    if (this.aTitleOverrideIsSetDeep(filter)) return true;
    if (this.bTitleOverrideIsSetDeep(filter)) return true;
    if (this.relationTypeIdIsSetDeep(filter)) return true;
    if (this.aTitleIsSetDeep(filter)) return true;
    if (this.bTitleIsSetDeep(filter)) return true;
    if (this.isDeletedIsSetDeep(filter)) return true;
    if (this.isNewIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
